import React from 'react';
import { Button } from '@tracekit/core';
import { getIndustryNewsTotalPages } from '../utils/industryNewsConstants';

interface IndustryNewsPaginationProps {
  page: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  className?: string;
}

/** Always visible when there is at least one item (shows "Page 1 of 1" for small lists). */
export function IndustryNewsPagination({
  page,
  totalItems,
  onPageChange,
  className = 'flex items-center justify-between pt-3 border-t mt-3',
}: IndustryNewsPaginationProps) {
  if (totalItems <= 0) {
    return null;
  }

  const totalPages = getIndustryNewsTotalPages(totalItems);

  return (
    <div className={className}>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1}
      >
        Previous
      </Button>
      <span className="text-sm text-gray-600 dark:text-gray-400">
        Page {page} of {totalPages}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
      >
        Next
      </Button>
    </div>
  );
}
